// /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/hooks/ScrollToTop.tsx

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, key } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, key]);

  return null;
}